"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var Tip = /** @class */ (function () {
    function Tip() {
        this.elm = d3.select("body").select(".bvd3-tooltip");
        if (this.elm.empty()) {
            this.elm = d3.select("body").append("div")
                .attr("class", "bvd3-tooltip")
                .style("opacity", "0")
                .style("padding", "5px")
                .style("font-size", "11px");
        }
    }
    Tip.prototype.style = function (name, value) {
        if (typeof value === "string") {
            this.elm.style(name, value);
        }
        else {
            this.elm.style(name, value.toString());
        }
        return this;
    };
    Tip.prototype.attachTo = function (element) {
        return new TipControl(this, element);
    };
    Tip.prototype.showTip = function () {
        this.elm.style("opacity", "1").style("pointer-events", "auto");
    };
    Tip.prototype.hideTip = function () {
        this.elm.style("opacity", "0").style("pointer-events", "none");
    };
    Tip.prototype.updateTipPos = function () {
        var event = d3.event;
        this.elm
            .style("left", event.pageX - window.scrollX + "px")
            .style("top", event.pageY - window.scrollY + 20 + "px");
    };
    return Tip;
}());
exports.Tip = Tip;
var TipControl = /** @class */ (function () {
    function TipControl(tip, element) {
        var _this = this;
        this.offset = [20, 20];
        this.tip = tip;
        this.element = element;
        this.element.on("mouseover", function (d, i, arr) {
            var data = _this._getData(d);
            if (_this.renderCallback) {
                var text = _this.renderCallback.call(_this, data, i, arr);
                if (text === undefined) {
                    return;
                }
                _this.tip.elm.html(text);
            }
            _this.tip.showTip();
            if (_this.appearCallback) {
                _this.appearCallback.call(_this, data, i, arr);
            }
        }).on("mouseout", function (d, i, arr) {
            _this.tip.hideTip();
            var data = _this._getData(d);
            if (_this.hideCallback) {
                _this.hideCallback.call(_this, data, i, arr);
            }
        }).on("mousemove", function (d, i, arr) {
            _this.tip.updateTipPos();
            var data = _this._getData(d);
            if (_this.moveCallback) {
                _this.moveCallback.call(_this, data, i, arr);
            }
        });
    }
    TipControl.prototype.datum = function (userData) {
        this.userData = userData;
        return this;
    };
    TipControl.prototype.renderHTML = function (callback) {
        this.renderCallback = callback;
        return this;
    };
    TipControl.prototype.onAppear = function (callback) {
        this.appearCallback = callback;
        return this;
    };
    TipControl.prototype.onHide = function (callback) {
        this.hideCallback = callback;
        return this;
    };
    TipControl.prototype.onCursorMove = function (callback) {
        this.moveCallback = callback;
        return this;
    };
    TipControl.prototype._getData = function (dData) {
        return (this.userData || dData);
    };
    return TipControl;
}());
exports.TipControl = TipControl;
function create(cls) {
    if (cls === void 0) { cls = null; }
    var tip = new Tip();
    // if (cls) {
    //     cls.split(" ").forEach(c => tip.elm.classed(c, true));
    // }
    return tip;
}
exports.create = create;
//# sourceMappingURL=tooltip.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/ui/tooltip.js
// module id = 877
// module chunks = 0 1